<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      :id="`input-shipping_address_address_1`"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractSignupTextInput from "../core/AbstractSignupTextInput";
import BaseInputMixin from "@/mixins/signupInputMixin";
import InputWidget from "@/components/core/InputWidget.vue";

export default {
  name: "ShippingAddress1",
  components: {InputWidget, AbstractSignupTextInput},
  mixins: [BaseInputMixin('shipping_address.address_1')],
  props: {
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      name: 'shipping_address.address_1',
      defaultLabel: this.$t("Address 1")
    }
  }
}
</script>

<style scoped>

</style>
